// CSS Modules - component class name prefix: Search__

<template>
  <div :class="$style.search">
    <input
      type="text"
      v-model="inputField"
      :placeholder="searchPlaceholder"
      maxlength="30"
      :class="$style.globalSearch"
      @input.prevent="handleChange"
      @keyup.delete="handleReset"
    />
    <label @click.prevent="handleSubmit">
      <input
        type="submit"
        :title="searchPlaceholder"
        value=""
        :class="$style.submitButton"
      />
      <i class="fas fa-search"></i>
    </label>
    <div :class="$style.loadingSpinner">
      <img alt="Loading..." :src="loadingGif" />
    </div>
  </div>
</template>

<script>
import LoadingGif from "../../assets/loading.gif";

export default {
  name: "Search",
  props: {
    searchPlaceholder: {
      type: String
    },
    selectedSuggestion: {
      type: String
    },
    model: {
      type: Array,
      default: () => []
    }
  },
  data: () => {
    return {
      inputField: "",
      loadingGif: LoadingGif
    };
  },
  methods: {
    handleSubmit() {
      this.$emit("submitted", this.inputField.split(" "));
    },
    handleReset() {
      this.$emit("reset", this.inputField);
    },
    handleChange() {
      if (this.inputField !== "") {
        this.$emit("active", this.inputField);
      } else {
        this.$emit("inactive", this.inputField);
      }
    }
  },
  watch: {
    selectedSuggestion: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.inputField = newValue;
      }
    },
    model: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.inputField = newValue.toString().replace(/,/g, " ");
      }
    }
  }
};
</script>

<style module lang="scss">
@import "./Search.scss";
</style>
